import React, { Component } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Notification, NotificationGroup } from "@progress/kendo-react-notification";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { MsalContext } from "@azure/msal-react";
import { updateNode } from "../Helpers/Nodes";
import { UpdateUser } from "../Helpers/AzureAD";
//import InviteUserDailog from "../OrganizationSettings/UserManagement/InviteUserDailog";
import { Dropdown } from "react-bootstrap";
import Theme from "./Theme";
import OrganizationSelector from "../Shared/organizationSelector/organizationSelector";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import PublishToRuntime from "../PublishToRuntime/PublishToRuntime";
import { callApiWithAuthorization } from "../../API/CallApi";
import SuccessfulPublishDialog from "../PublishToRuntime/SuccessfulPublish";
import { useSearchParams } from "react-router-dom";
import { OverlayLoader } from "../Shared/Loader/OverlayLoader";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { getAzureUser } from "../../API/User/User";

function withSearchParams(Component) {
	function Wrapper(props) {
		const [searchParams, setSearchParams] = useSearchParams();

		return (
			<Component
				{...props}
				searchParams={searchParams}
				setSearchParams={setSearchParams}
			/>
		)
	}

	return Wrapper;
}

class NavigationComponent extends Component {
	static contextType = MsalContext;
	anchor = null;
	lastPublishedAppUrl = "";
	lastPublishedInstance = {};

	iframe;

	constructor(props) {
		super(props);

		this.state = {
			showloader: false,
			OrgName: this.props.OrgName,
			visible: false,
			showLaunchPopup: false,
			showPreviewPopup: false,
			showUserDialog: false,
			showDisplayResetWarning: false,
			userId: "",
			email: "",
			userData: {},
			currentOrgnization: {},
			notificationMessage: "",
			redirect: false,
			loading: false,
			AddDialog: false,
			firstName: "",
			lastName: "",
			displayName: "",
			jobTitle: "",
			projectName: "",
			bgColor: "",
			showInvitePopup: false,
			organizations: this.props.organizations,
			selectedOrg: this.props.selectedOrg,
			isPreviewDialogOpen: false,
			isPublishDialogOpen: false,
			showSuccessfulPublishDialog: false,
			startLogout: false
		};

		this.publishRef = React.createRef();
		this.previewRef = React.createRef();
	}

	componentDidMount = async () => {
		document.addEventListener("click", this.handlePopups);
		window.addEventListener("message", this.handleMessage);

		let { context } = this;

		let { user } = this.props;

		let { organizations, OrgName } = this.props
		let currentOrgnization = {}
		if (organizations !== undefined) {
			currentOrgnization = organizations.find(org => org.number === OrgName)
		}
		if (!user && !user.id) {
			localStorage.clear();
			context.instance.logoutRedirect();
		}
		const showSuccessfulPublishDialog = this.props.searchParams.get("showSuccessfulPublishDialog") === "true";
		const instanceId = this.props.searchParams.get("instanceId");
		const runtimeUrl = this.props.searchParams.get("url");
		this.setLastPublishedInstance({ id: instanceId });
		this.setPublishedAppUrl(runtimeUrl);
		this.props.setSearchParams(this.props.searchParams);
		this.setState({
			userData: user,
			firstName: user.firstName || "",
			lastName: user.lastName || "",
			jobTitle: user.jobTitle || "",
			displayName: user.displayName || "",
			//companyName: user.companyName || "",
			email: user.email,
			userId: user.id,
			bgColor: user.bgColor,
			currentOrgnization,
			showSuccessfulPublishDialog
		});
	};

	removeAccessTokenFromRuntime = () => {
		if (this.iframe && this.iframe.contentWindow) {
			this.iframe.contentWindow.postMessage({ type: "LOGOUT" }, "*");
		}
	}

	handleMessage = (event) => {
		if (event.origin === process.env.REACT_APP_RUNTIME_URL) {
			const data = JSON.parse(event.data);
			if (data.status === "Success") {
				this.signOut();
			}
		}
	}

	togglePreview = () => { this.setState({ isPreviewDialogOpen: !this.state.isPreviewDialogOpen }); }
	togglePublish = () => { this.setState({ isPublishDialogOpen: !this.state.isPublishDialogOpen }); }

	handlePopups = (e) => {

		if (this.launcher !== null && this.state.showLaunchPopup) {
			if (this.launchComponent.instanceComponent && this.launchComponent.instanceComponent.popup && this.launchComponent.instanceComponent.popup !== null) {
				if (!this.launchComponent.instanceComponent.popup.contains(e.target) && !this.launcher.contains(e.target) && !(e.target === this.anchor)) {
					this.setState({ showLaunchPopup: false });
				}
			} else {
				if (!this.launcher.contains(e.target) && !(e.target === this.anchor) & !e.target.classList.contains("publish-button")) {
					this.setState({ showLaunchPopup: false });
				}
			}
		}
		if (this.userPopup !== null && this.state.showUserPopup) {
			if (!this.userPopup.contains(e.target) && !(e.target === this.userAnchor) && !this.userAnchor.contains(e.target)) {
				this.setState({ showUserPopup: false });
			}
		}
	};

	componentWillUnmount() {
		document.removeEventListener("click", this.handlePopups);
	}

	showLaunchPopup = (e) => {
		this.setState({
			showLaunchPopup: !this.state.showLaunchPopup,
		});
	};

	showPreviewPopup = (e) => {
		this.setState({
			showPreviewPopup: !this.state.showPreviewPopup,
		});
	};

	showUserPopup = () => {
		this.setState({ showUserPopup: !this.state.showUserPopup });
	};

	ShowInvitePopup = (userAdded, notificationMessage) => {
		this.setState({
			userAdded: userAdded,
			notificationMessage: notificationMessage,
			showInvitePopup: !this.state.showInvitePopup,
		});
		if (userAdded) {
			setTimeout(() => {
				this.setState({
					notificationMessage: "",
					userAdded: false,
				});
			}, 2000);
		}
	};

	toggleShowUserDialog = () => {
		this.setState({
			showUserDialog: !this.state.showUserDialog,
			showUserPopup: false,
			showInvitePopup: false,
			firstName: this.state.userData.firstName,
			lastName: this.state.userData.lastName,
			displayName: this.state.userData.displayName,
		});
	};

	handleEmail = (e) => {
		this.setState({
			Email: e.target.value,
		});
	};

	handleGivenName = (e) => {
		this.setState({
			firstName: e.target.value,
		});
	};

	handleSurname = (e) => {
		this.setState({
			lastName: e.target.value,
		});
	};

	handleDisplayName = (e) => {
		this.setState({
			displayName: e.target.value,
		});
	};

	// handleCompanyName = (e) => {
	//     this.setState({
	//         companyName: e.target.value,
	//     });
	// };

	handleJobTitle = (e) => {
		this.setState({
			jobTitle: e.target.value,
		});
	};

	goToEntity = () => {
		window.location.href = `/${this.props.OrgName}/${this.props.projectName}/Entities`;
	};

	updateuser = async (e) => {
		e.preventDefault();
		let { context } = this;
		const userAdData = await getAzureUser(context);

		updateNode("User", this.state.userId, {
			firstName: this.state.firstName,
			lastName: this.state.lastName,
			jobTitle: this.state.jobTitle,
			//companyName: this.state.companyName,
			displayName: this.state.displayName,
		});
		let userObj = {
			Id: userAdData.oid,
			firstName: this.state.firstName,
			lastName: this.state.lastName,
			jobTitle: this.state.jobTitle,
			displayName: this.state.displayName,
		};
		UpdateUser(userObj);
		let userInfo = this.state.userData;
		userInfo.firstName = this.state.firstName;
		//userInfo.companyName = this.state.companyName;
		userInfo.lastName = this.state.lastName;
		userInfo.displayName = this.state.displayName;
		userInfo.jobTitle = this.state.jobTitle;
		this.setState({
			userData: userInfo,
		});
		this.toggleShowUserDialog();
	};

	shouldDisabled = () => {
		let condition = this.state.displayName !== this.state.userData.displayName || this.state.firstName !== this.state.userData.firstName || this.state.lastName !== this.state.userData.lastName || this.state.jobTitle !== this.state.userData.jobTitle;
		// ||this.state.companyName !== this.state.userData.companyName;
		if (this.state.displayName === "" || this.state.email === "") {
			condition = true;
		}

		if (condition) {
			return false;
		} else {
			return true;
		}
	};

	handlePreview = async () => { };

	openRuntimeInIframe = () => {
		this.setState({ startLogout: true });
	}

	signOut = async () => {
		this.setState({ showloader: true });

		updateNode("User", this.state.userData.id, { lastOrganizationAccessed: this.props.OrgName });

		localStorage.clear();
		const { context } = this;
		const logoutRequest = { account: context.instance.getAccountByHomeId(context.accounts[0].homeAccountId) };

		context.instance.logoutRedirect(logoutRequest);

		this.setState({ showloader: false });
	};

	toggleDisplayResetWarning = (e) => {
		this.setState({
			showDisplayResetWarning: !this.state.showDisplayResetWarning,
		});
	};

	toggleSuccessfulPublishDialog = () => {
		this.setState({
			showSuccessfulPublishDialog: !this.state.showSuccessfulPublishDialog
		});
		this.props.searchParams.delete("showSuccessfulPublishDialog");
		this.props.searchParams.delete("instanceId");
		this.props.searchParams.delete("url");
		this.props.setSearchParams(this.props.searchParams);
	}

	setPublishedAppUrl = (url) => {
		this.lastPublishedAppUrl = url;
	}

	setLastPublishedInstance = (instance) => {
		this.lastPublishedInstance = { ...instance };
	}

	handlePreviewDropdown = (event) => { };

	handlePublishDropdown = (event) => { };

	updateUserState = (userData) => {
		this.setState({ userData })
	}

	openRuntimeInNewTab = () => {
		const Url = process.env.REACT_APP_RUNTIME_URL + "/" + this.state.currentOrgnization.url
		window.open(Url, "_blank").focus();
	}

	render() {
		return (
			<>
				{
					this.state.startLogout &&
					<iframe
						src={`${process.env.REACT_APP_RUNTIME_URL}/local-storage`}
						height={0}
						width={0}
						ref={iframe => {
							this.iframe = iframe;
							if (iframe) {
								iframe.addEventListener("load", () => {
									iframe.contentWindow.postMessage(
										JSON.stringify({ type: "LOGOUT" }), "*"
									);
								})
							}
						}} />
				}
				{this.state.showloader &&
					<OverlayLoader />
				}
				{
					this.state.userAdded &&
					<NotificationGroup style={{ top: 0, left: "50%", transform: "translateX(-50%)" }}>
						<Notification
							key="success"
							closable={true}
							type={{
								style: "success",
								icon: true,
							}}
						>
							{this.state.notificationMessage}
						</Notification>
					</NotificationGroup>
				}
				{/* {this.state.showInvitePopup && (
					<Dialog width={"50%"} title={"Invite Users to App Maker"} onClose={() => this.ShowInvitePopup(false)} className="user-popup">
						<InviteUserDailog organizations={this.props.organizations} orgName={this.props.OrgName} userRole={this.props.userRole} ShowInvitePopup={this.ShowInvitePopup} />
					</Dialog>
				)} */}

				{this.state.showSuccessfulPublishDialog &&
					<SuccessfulPublishDialog
						user={this.props.user}
						onClose={this.toggleSuccessfulPublishDialog}
						updateUserState={this.updateUserState}
						workspaceUrl={this.lastPublishedAppUrl}
						instance={this.lastPublishedInstance} />
				}

				{this.state.showUserDialog && (
					<Dialog title={"Edit User Information"} onClose={this.toggleShowUserDialog}>
						<form onSubmit={this.updateuser}>
							<div className="form-label" required>
								Email
							</div>
							<input type="email" className="form-control" value={this.state.userData.email} disabled={true} />
							<div className="form-label">First Name</div>
							<input autoFocus={true} value={this.state.firstName} onChange={this.handleGivenName} className="form-control" />
							<div className="form-label">Last Name</div>
							<input value={this.state.lastName} onChange={this.handleSurname} className="form-control" />

							<div className="form-label" required>
								Display Name
							</div>
							<input value={this.state.displayName} onChange={this.handleDisplayName} className="form-control" />

							<div className="form-label">Role</div>
							<DropDownList className="form-control-custom" value={this.state.jobTitle} data={["Business Analyst", "IT Professional", "Manager", "Professional Developer", "Project Manager", "Product Owner", "Scrum Master", "Other"]} onChange={this.handleJobTitle} />

							{/* <div className="form-label">Company Name</div>
                            <input
                                value={this.state.companyName}
                                onChange={this.handleCompanyName}
                                className="form-control"
                            /> */}
							<DialogActionsBar layout="end">
								<button onClick={this.toggleShowUserDialog} type="button" className="mx-1 btn btn-secondary">
									Cancel
								</button>
								<button onClick={this.updateuser} disabled={this.shouldDisabled()} type={'submit'} className="btn btn-primary">
									Update
								</button>
							</DialogActionsBar>
						</form>
					</Dialog>
				)}

				<div className="d-flex top-nav align-items-center border-bottom nav">
					<div className="ms-2 logo-container">
						<a href={this.props.OrgName ? `/${this.props.OrgName}` : `/${localStorage.getItem("selectedOrganization")}`}>
							<img alt="LOGO" className="logo light-logo" src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/codeless-one-logo.svg`} />
						</a>
					</div>
					<div className="position-relative flex-grow-1 d-flex align-items-center" style={{ height: 47 }}>
						<div className="flex-grow-1">
							<Breadcrumb>{this.state.selectedOrg ? <OrganizationSelector selectedOrg={this.state.selectedOrg} homePage={this.props.match ? true : false} organizations={this.state.organizations} user={this.state.userData} /> : this.props.children}</Breadcrumb>
						</div>

						{
							this.props.showWorkspaceButton &&
							<button onClick={this.openRuntimeInNewTab} title="Go to Workspace" className="btn btn-link">
								<i class="fa-solid fa-house-laptop workspaceButton"></i>
							</button>
						}
						{this.props.projectName !== undefined && (
							<>
								<div>
									<button title={"Publish"} className="me-2 btn btn-primary project-fourth-step" onClick={this.togglePublish}>
										<i class="fas fa-rocket mx-1"></i>
										<span className="d-none d-md-inline">Publish</span>
									</button>
									{this.state.isPublishDialogOpen &&
										<PublishToRuntime
											forPreview={false}
											launchType="production"
											projectId={this.props.projectId}
											organizations={this.props.organizations}
											orgName={this.props.OrgName}
											projectUrl={this.props.projectUrl}
											projectName={this.props.projectName}
											toggleDisplayResetWarning={this.toggleDisplayResetWarning}
											toggleDialog={this.togglePublish}
											showSuccess={this.toggleSuccessfulPublishDialog}
											setUrl={this.setPublishedAppUrl}
											user={this.state.userData}
											setLastPublishedInstance={this.setLastPublishedInstance}
										/>
									}
								</div>
							</>
						)}
					</div>
					{/* {this.props.userRole !== "Member" && !this.props.hideInviteButton && (
						<Tooltip anchorElement="target" position="bottom" tooltipClassName="kendo-tool-tip">
				        <button
						    type="button"
							onClick={() => this.ShowInvitePopup(false)}
							disabled={this.props.userRole === "Member" ? true : false}
							ref={(button) => {this.inviteAnchor = button;}}
							title="Invite your team"
							className="btn-invite">
							<i className="fa-solid fa-user-plus"title="Invite your team"></i>
						</button>
					    </Tooltip>
					)} */}

					<Dropdown>
						<Dropdown.Toggle className="clean-dropdown no-button-hover">
							<div style={{ backgroundColor: this.state.bgColor }} className="inline-block mx-2 pointer circle align-items-center justify-content-center d-flex">
								{this.state.email.substring(0, 2).toUpperCase()}
							</div>
						</Dropdown.Toggle>
						<Dropdown.Menu className="preview-panel-parent shadow border wide-panel">
							<div className="py-2 row border-bottom">
								<div className="p-0 text-center col-4">
									<img alt="" src="https://www.w3schools.com/howto/img_avatar.png" className="rounded-circle" style={{ width: "50px" }} />
									<div className="mt-2 link " type="button" onClick={this.toggleShowUserDialog}>
										Edit Profile
									</div>
								</div>
								<div className="p-0 mt-2 col-8">
									{/* <div>First Name: <b>{this.state.firstName}</b></div>
										<div>Last Name: <b>{this.state.lastName}</b></div> */}
									<div className="mb-2">
										<strong>{this.state.displayName !== "" ? this.state.displayName : this.state.firstName !== "" ? this.state.firstName + ' ' + this.state.lastName : this.state.email.split('@')[0]}</strong>
									</div>
									<div>
										<p className="p-0 mb-1 mr-0 text-truncate" title={this.state.email}>
											{this.state.email}
										</p>
									</div>
								</div>
							</div>
							{
								this.state.currentOrgnization && this.state.currentOrgnization.internalMode &&
								<div className="border-bottom">
									<Theme user={this.state.userData} />
								</div>
							}
							<div className="px-2 pt-2 float-end">
								<button title="Sign out" className="btn btn-secondary" onClick={this.openRuntimeInIframe}>
									Sign Out
								</button>
							</div>
						</Dropdown.Menu>
					</Dropdown>

					<div
						title="User"
						onClick={this.showUserPopup}
						ref={(button) => {
							this.userAnchor = button;
						}}
					></div>
				</div>
			</>
		);
	}
}

export default withSearchParams(NavigationComponent);
